/**************************************************
 * Nombre:       Dialogo_Tipo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Categoria from "../Formularios/Formulario_Categoria";
import {guardarFechaAct} from "../../Servicios/BD/Actualizadores/guardarFechaAct";
import Formulario_Tipo from "../Formularios/Formulario_Tipo";

const Dialogo_Tipo = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')
        entidad.fecha = new Date().getTime()
        let resultado = await subirImagenHostingFile(entidad.img)
        entidad.img = resultado.data
        entidad.prioridad = entidad.prioridad ? parseInt(entidad.prioridad) : 100
        nuevoAviso({aviso: 'Imagen subida'})

        await guardarFechaAct('tipos')
        let dox = await guardarDoc('tipos', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('tipos', datos.id)
        terminar({aviso: 'Tipo borrada'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Tipo props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Tipo